<template>
    <VJoyCollapse v-model="model" :accordion="true" class="mkt-c-faq-accordion">
        <VJoyCollapseItem
            v-for="(item, index) in props.faqItems"
            :id="asText(item.questionTitle)"
            :key="`faq-item--${index}`"
            :header="asText(item.questionTitle)"
            class="slice-faq__item"
        >
            <PrismicRichText :field="item.answer" class="slice-faq__answer" />
        </VJoyCollapseItem>
    </VJoyCollapse>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {asText} from '@prismicio/helpers';
    import type {RichTextField} from '@prismicio/types';
    import {PrismicRichText} from '@prismicio/vue';
    import {VJoyCollapse, VJoyCollapseItem} from '@maltjoy/core-vue';

    type FaqItem = {
        questionTitle: RichTextField;
        answer: RichTextField;
    };
    type FaqAccordionProps = {
        faqItems: FaqItem[];
    };

    const props = defineProps<FaqAccordionProps>();

    const model = ref<string[]>([]);
</script>
<style lang="scss">
    .mkt-c-faq-accordion {
        border: 1px solid var(--joy-color-neutral-30);
        border-radius: var(--joy-core-radius-4);
        box-shadow: var(--joy-core-elevation-1);
        padding: var(--joy-core-spacing-2) var(--joy-core-spacing-6);

        .slice-faq__answer {
            margin-bottom: var(--joy-core-spacing-4);
        }
    }
</style>
